import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';

import type {
  Action,
  CampaignOverview,
  CampaignType,
  CcmCampaignOverview,
  ThunkAction
} from 'types';

const RECEIVE = 'campaignOverview/RECEIVE';
const RECEIVE_CCM = 'campaignOverview/RECEIVE_CCM';
const RESET = 'campaignOverview/RESET';
const LOADING_STATE_CHANGED = 'campaignOverview/LOADING_STATE_CHANGED';

const { CAMPAIGNS } = API.END_POINTS;

const initialState = {
  overview: null,
  ccmOverview: null,
  isLoading: false
};

function receiveOverview(overview: CampaignOverview): Action {
  return {
    type: RECEIVE,
    payload: {
      overview
    }
  };
}

function receiveCcmOverview(ccmOverview: CcmCampaignOverview): Action {
  return {
    type: RECEIVE_CCM,
    payload: {
      ccmOverview
    }
  };
}

export function loadingStateChanged(isLoading: boolean): Action {
  return {
    type: LOADING_STATE_CHANGED,
    payload: {
      isLoading
    }
  };
}

export function resetCampaignOverview(): Action {
  return {
    type: RESET,
    payload: {}
  };
}

export function fetchCampaignOverview(campaignId: number, campaignType: CampaignType = 'collab'): ThunkAction {
  const url = CAMPAIGNS.getCampaignOverview(campaignId, campaignType);

  return (dispatch) => {
    dispatch(loadingStateChanged(true));

    return get(url)
      .then(response => {
        if (campaignType === 'ccm') {
          dispatch(receiveCcmOverview(response.data));
        } else {
          dispatch(receiveOverview(response.data));
        }

        dispatch(loadingStateChanged(false));
      })
      .catch((error) => {
        dispatch(loadingStateChanged(false));

        throw error;
      });
  };
}

export default createReducer<any, any>('campaignOverview', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE]: (state, { overview }) => ({
    ...state,
    overview
  }),
  [RECEIVE_CCM]: (state, { ccmOverview }) => ({
    ...state,
    ccmOverview
  }),
  [LOADING_STATE_CHANGED]: (state, { isLoading }) => ({
    ...state,
    isLoading
  })
});
